import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Card,
  Divider,
  Icon,
  Typography
} from '@material-ui/core';
import { useStyles } from '../styles';
import SearchPatient from './SearchPatient';
import QuoteCreatePatient from './QuoteCreatePatient';


const QuotePatient = () => {
  const classes = useStyles();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const [searchPatientModalOpen, setSearchPatientModalOpen] = useState(false);
  const [addPatientModalOpen, setAddPatientModalOpen] = useState(false);

  return (
    <>
      <Card className="mx-10 p-8 root-card">
        <Typography variant="h6" gutterBottom className="mb-4">
          {isCustomer3 ? 'Customer' : 'Patient'}
        </Typography>
        <Divider />
        <Box
          mt={3}
          px={2}
          py={4}
          border={1}
          display="flex"
          justifyContent="space-between"
          borderRadius={4}
          borderColor="grey.300"
        >
          <Button
            color="primary"
            variant="outlined"
            size="large"
            className={`${classes.customQuotePatientButton} mr-2`}
            onClick={() => setSearchPatientModalOpen(true)}
          >
            <Icon className={classes.customIcon}>search</Icon>
            <span className="capitalize">Search</span>
          </Button>
          <Button
            color="primary"
            variant="outlined"
            size="large"
            className={`${classes.customQuotePatientButton} ml-2`}
            onClick={() => setAddPatientModalOpen(true)}
          >
            <Icon className={classes.customIcon}>control_point</Icon>
            <span className="capitalize">{`Add New ${isCustomer3 ? 'Customer' : 'Patient'}`}</span>
          </Button>
        </Box>
      </Card>
      <SearchPatient open={searchPatientModalOpen} onClose={() => setSearchPatientModalOpen(false)} />
      <QuoteCreatePatient open={addPatientModalOpen} onClose={() => setAddPatientModalOpen(false)} />
    </>
  );
};

export default QuotePatient;
